import $ = require('jquery');
import { ListWidgetService } from "../service.listwidgets";
import {WebSocket} from "../websocket";
import { Utility} from '../utility';

export class roadContionsType {
    dist: string;
    isDistNum: boolean;
}

export default class roadConditionsController {
    static $inject = ["$scope", "$http", "ListWidgetService"];
    static AngularDependencies = ['$scope', '$http', 'ListWidgetService', roadConditionsController];

    private oldData: any;

    public roadConditionTypes = ["Seasonal", "Partially Covered", "Completely Covered", "Travel Not Advised", "Impassable"];
    public districtInfoArray: roadContionsType[] = [];

    public roadConditionsList = {
      district: [],
      "Seasonal": [],
      "Partially Covered": [],
      "Completely Covered": [],
      "Travel Not Advised": [],
      "Impassable": []
    };

    public roadConditions: any;
    public roadConditionsDistricts: any;
    public sumtotal: number;

    public updateRoadConditions(data) {
        this.roadConditions = data.RoadCondition;
        this.roadConditionsDistricts = data.RoadCondition_District;
        var districtValueInParam = Utility.getQueryVariable("district");
        // Reset the local data.
        this.sumtotal = 0;
        this.roadConditionsList = {
            district: [1,2,3,4,5,6],
            "Seasonal": [0,0,0,0,0,0],
            "Partially Covered": [0,0,0,0,0,0],
            "Completely Covered": [0,0,0,0,0,0],
            "Travel Not Advised": [0,0,0,0,0,0],
            "Impassable": [0,0,0,0,0,0]
        };

        this.districtInfoArray.push({
            dist: districtValueInParam,
            isDistNum: (Number(districtValueInParam) >= 1 && Number(districtValueInParam) <= 6) ? true : false
        });

        // Update the local data with the received value.
        for (let x = 0; x < this.roadConditionsDistricts.length; x++) {
            this.roadConditionsList[this.roadConditionsDistricts[x].road_condition][this.roadConditionsDistricts[x].road_district-1] = this.roadConditionsDistricts[x].road_percentage*100;
        }

        for (let conditionType in this.roadConditionTypes) {
          this[conditionType] = 0;
        }

        for (let x = 0; x < this.roadConditions.length; x++) {
          this[this.roadConditions[x].road_condition_total] = (Math.round(this.roadConditions[x].road_percentage_total*1000))/10;
        }

        this.oldData = data.RoadCondition;
        this.ListWidgetService.updatecount("Road Conditions", this.districtInfoArray.length);
    }

    constructor($scope: ng.IScope, $http: angular.IHttpService, public ListWidgetService: ListWidgetService) {
        let vm = this;

        WebSocket.OnUpdate(function(data) {
            if(!Utility.deepEqual(vm.oldData,data.RoadCondition)){
                vm.updateRoadConditions(data);
                $scope.$digest();
                $scope.$broadcast("data_ready");
            }
        });

        for (let roadConditionType of this.roadConditionTypes) {
            this[roadConditionType] = 0;
        }

        var acc = document.getElementsByClassName("topbar");
        var i;
        for (i = 0; i < acc.length; i++) {
            var test = <any>acc[i]
            test.onclick = function () {
                this.classList.toggle("active");
                this.nextElementSibling.children[0].classList.toggle("hide");
            }
        }

        $scope.$broadcast("data_ready");
    }
}



// WEBPACK FOOTER //
// ./src/app/roadconditions/controller.roadconditions.ts